import { useLazyQuery, useQuery } from "@apollo/client/react";import { useEffect, useState } from "react";

import { adaptGestionAsistencialArray } from "../../../adapters/gestionAsistencial/adaptGestionAsistencialArray";
import { GET_GESTION_PACIENTES_ASISTENCIAL } from "../../../data/graphQL/queries/GestionAsistencial/getGestionPacientesAsistencial";
import { GET_USUARIO_DELEGACION_ORIGEN } from "../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen";
import { ID_ESTADO_PACIENTE_ALTA } from "../components/GestionAsistencialContent";

const userId = sessionStorage.getItem("idUsuario");

export function useGestionAsistencialRows({
  filters,
  handleChangeFilters,
  resetInitialValues,
  estadoPaciente
}) {
  const [rows, setRows] = useState([]);
  const [originalData, setOriginalData] = useState([]);

  const [getGestionAsistencial, { data: dataGestionAsistencial, loading: loadingGestionAsistencial }] =
  useLazyQuery(GET_GESTION_PACIENTES_ASISTENCIAL, {
    fetchPolicy: "no-cache"
  });

  useEffect(() => {
    if (!dataGestionAsistencial) return;
    const dataAdapted = adaptGestionAsistencialArray(dataGestionAsistencial);
    setOriginalData(dataAdapted);

    const dataFilteredFromClientSide = applyClientSideFilters(
      dataAdapted,
      filters.txtFiltro
    );
    setRows(dataFilteredFromClientSide);
  }, [dataGestionAsistencial]);


  const { data: dataUsuarioDelegacion, loading: loadingUsuarioDelegacion } =
  useQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: "no-cache",
    variables: { idUsuario: JSON.parse(userId, 10) }
  });

  const handleSearch = (idDelegacionParam) => {
    const idDelegacion = filters.idDelegacion || +idDelegacionParam;
    const isAltaState = filters.idEstadoPaciente === ID_ESTADO_PACIENTE_ALTA;

    resetInitialValues();

    getGestionAsistencial({
      variables: {
        idDelegacion,
        idEstado: filters.idEstadoPaciente,
        ...(isAltaState && {
          fechaDesde: filters.fechaDesde,
          fechaHasta: filters.fechaHasta
        })
      }
    });
  };

  const applyTextFilter = (data, textFilter) => {
    const inputBuscar = textFilter?.trim().toUpperCase();

    if (inputBuscar === "") return data;

    const dataFiltered = data.filter((asistential) => {
      const contrato = asistential.contrato.toString().toUpperCase();
      const paciente = asistential.paciente.toString().toUpperCase();
      const pacienteSAP = asistential.pacienteSAP.toString().toUpperCase();
      const hc = asistential.hc.toString().toUpperCase();
      const edad = asistential?.edad?.toString().toUpperCase() || "";
      const clienteSAP = asistential?.clienteSAP?.toString().toUpperCase() || "";
      const nombreCliente = asistential?.nombreCliente?.toString().toUpperCase() || "";
      const nombrePlan = asistential.nombrePlan.toString().toUpperCase() || "";
      const programa = asistential.programa.toString().toUpperCase() || "";

      return (
        contrato.includes(inputBuscar) ||
        hc.includes(inputBuscar) ||
        pacienteSAP.includes(inputBuscar) ||
        paciente.includes(inputBuscar) ||
        edad.includes(inputBuscar) ||
        clienteSAP.includes(inputBuscar) ||
        nombreCliente.includes(inputBuscar) ||
        nombrePlan.includes(inputBuscar) ||
        programa.includes(inputBuscar));

    });

    return dataFiltered;
  };

  const applyEstadoPacienteFilter = (data, estadoPacienteFilter) => {
    const esProbable = estadoPacienteFilter === estadoPaciente?.find((x) => x.displayName === 'Probable')?.id;
    const estadoPacienteNuevo = estadoPaciente?.find((x) => x.displayName === 'Nuevo')?.id;

    const dataFiltered = data.filter(
      (asistencial) => esProbable && (asistencial.idEstadoPaciente === +estadoPacienteFilter ||
      asistencial.idEstadoPaciente === estadoPacienteNuevo) ||

      !esProbable && asistencial.idEstadoPaciente === +estadoPacienteFilter
    );

    return dataFiltered;
  };

  const applyClientSideFilters = (data, textFilter) => {
    const dataFilteredByText = applyTextFilter(data, textFilter);

    // const dataFilteredByEstadoPaciente = applyEstadoPacienteFilter(
    //   dataFilteredByText,
    //   estadoFilter
    // );

    return dataFilteredByText;
  };

  useEffect(() => {
    if (dataUsuarioDelegacion && !loadingUsuarioDelegacion) {
      if (!dataUsuarioDelegacion) return;
      const { success, valorEsperado } = dataUsuarioDelegacion?.usuarioFull || {};
      if (success) {
        const deleg = valorEsperado.delegacionOrigen;
        sessionStorage.setItem("delegacionOrigen", deleg);

        if (filters.idDelegacion === 0) {
          handleChangeFilters("idDelegacion", deleg);
        }

        handleSearch(deleg);
      }
    }
  }, [dataUsuarioDelegacion, loadingUsuarioDelegacion]);

  return {
    rows,
    setRows,
    originalData,
    totalCount: rows.length || 0,
    loading: loadingGestionAsistencial || loadingUsuarioDelegacion,
    handleSearch,
    applyTextFilter,
    applyEstadoPacienteFilter,
    applyClientSideFilters
  };
}